var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.967 16.067a1.347 1.347 0 010 1.9 1.347 1.347 0 01-1.9 0l-4.422-4.423-4.423 4.422a1.336 1.336 0 01-1.9 0c-.534-.534-.564-1.335 0-1.9l4.423-4.422-4.423-4.422c-.504-.505-.593-1.306 0-1.9.594-.593 1.378-.522 1.9 0l4.423 4.423 4.422-4.423a1.347 1.347 0 011.9 0 1.347 1.347 0 010 1.9l-4.423 4.422 4.423 4.423z"
  })));
}
export default SvgClose;